/** Shared nav for public header & footer (in-app routes). */
export const PUBLIC_NAV_LINKS = [
  { label: "Products", to: "/products" },
  { label: "FAQs", to: "/faqs" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Contact Us", to: "/contact" },
];
